<template>
  <div>
    <main class="code d-flex" v-if="answers" style="z-index:2000" v-cloak>
      <div class="w-100">
        <div class="container">
          <div class="row" style="padding-bottom: 300px !important; overflow-y: scroll">
            <div class="col-12">
              <div v-for="(question, index) in questions" :key="question.id">
                <div
                  class="form-group survey-question"
                  style="height:auto"
                  v-show="index === currentQuestionNumber"
                >
                  <h5
                    class="mb-5 mt-5 mt-md-0"
                    style="font-size: 30px; font-weight:normal; margin-top: 4rem"
                  >{{question.question}}</h5>
                  <div class="pl-3 pr-3 form-group" style="position:relative">
                    <div v-if="question.type !== 'select'">
                      <div v-if="question.type === 'number'">
                        <label :for="'answer-'+index" class="h5">{{$t('Rispondi alla domanda')}}</label>
                        <input
                          :type="question['type']"
                          class="form-control form-survey-response"
                          :placeholder="$t('Enter your answer')"
                          step=".5"
                          :name="question.question"
                          v-validate="'required|numeric'"
                          v-model.trim="answers[index].answer"
                          data-vv-validate-on="change|blur"
                          autocomplete="off"
                          required
                        >
                        <span
                          v-show="errors.has(question.question)"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{ errors.first(question.question) }}</strong>
                        </span>
                      </div>
                      <div v-else-if="question.type === 'address'">
                        <label :for="'answer-'+index" class="h5">{{$t('Rispondi alla domanda')}}</label>
                        <input
                          type="text"
                          class="form-control addressAutocomplete form-survey-response"
                          :id="'answer-'+index"
                          :placeholder="$t('Enter your answer')"
                          v-gaddress
                          v-validate="'required|string'"
                          v-model="answers[index].answer"
                        >
                      </div>
                      <div v-else-if="question.type === 'city'">
                        <label class="h5">{{$t('Rispondi alla domanda')}}</label>
                        <input
                          type="text"
                          class="form-control cityAutocomplete form-survey-response"
                          :placeholder="$t('Enter your answer')"
                          v-gcity
                          v-validate="'required|string'"
                          v-model="answers[index].answer"
                        >
                      </div>
                      <div v-else-if="question.type === 'date'">
                        <label class="h5">{{$t('Rispondi alla domanda')}}</label>
                        <input
                          type="date"
                          class="form-control form-survey-response"
                          :placeholder="$t('Enter your answer')"
                          autocomplete="off"
                          name="answerDate"
                          v-validate="'required|date_format:yyyy-MM-dd'"
                          v-model.trim="answers[index].answer"
                          data-vv-validate-on="change|blur"
                          required
                        >
                        <span
                          v-show="errors.has('answerDate')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{ errors.first('answerDate') }}</strong>
                        </span>
                      </div>
                      <div v-else>
                        <label class="h5">{{$t('Rispondi alla domanda')}}</label>
                        <input
                          type="text"
                          class="form-control form-survey-response"
                          :placeholder="$t('Enter your answer')"
                          autocomplete="off"
                          name="textAnswer"
                          v-validate="'required'"
                          v-model.trim="answers[index].answer"
                          data-vv-validate-on="change|blur"
                          required
                        >
                        <span
                          v-show="errors.has('textAnswer')"
                          class="invalid-feedback"
                          style="position: relative; bottom: 0px; padding-bottom: 10px;"
                        >
                          <strong>{{ errors.first('textAnswer') }}</strong>
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <label class="h5">{{$t('Rispondi alla domanda')}}</label>
                      <div v-for="(option, indexOption) in question.options" :key="option.id">
                        <button
                          type="button"
                          :class="getSelectClass(option.v, index)"
                          class="btn btn-lg btn-block button-survey"
                          :value="indexOption"
                          style="font-size: 20px; font-weight:normal"
                          @click="setSelectAnswer(option.v, index, question.id)"
                        >{{option.v}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="survey-bar d-flex flex-row align-items-center" v-if="answers && answersCreated" v-cloak>
      <div
        class="container d-flex flex-row align-items-center justify-content-between"
        style="height:100%"
      >
        <div class="progress-status" style="width:50%;max-width:278px;" v-if="questions.length>1">
          <div class="text-primary">
            <span class="survey_complete_number">{{percCompleted}}</span>% completed
          </div>
          <div class="progress">
            <div
              class="progress-bar survey_complete_progress"
              :style="{width: percCompleted + '%'}"
              role="progressbar"
            ></div>
          </div>
        </div>
        <div class="navigate" v-if="questions > 1">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="currentQuestionNumber<=0"
            @click="currentQuestionNumber-=1"
          >
            <i class="far fa-arrow-left"></i>
          </button>
          <button
            type="submit"
            class="btn btn-primary btn-next"
            :disabled="!answers[currentQuestionNumber].answer || answers[currentQuestionNumber].answer ===''"
            v-if="currentQuestionNumber>=(questions.length)-1"
            @click="submitAnswers"
          >
            <i class="far fa-arrow-right"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary btn-next"
            :disabled="!answers[currentQuestionNumber].answer || answers[currentQuestionNumber].answer ==='' || (errors.items !== undefined && errors.items.length > 0)"
            v-else
            @click="currentQuestionNumber+=1"
          >
            <i class="far fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "survey",
  data() {
    return {
      questions: [],
      answers: [],
      currentQuestionNumber: 0,
      answersCreated: false
    };
  },
  async created() {
    this.$store.commit("showSpinner");
    try {
      let response = await this.$http.get(
        "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/surveys/" +
          this.$route.params.surveyId +
          "/questions"
      );

      this.questions = response.data.data;

      _.forEach(_.sortBy(this.questions, (question) => {
        return question.order
      }), (question, index) => {
        this.$set(this.answers, index, {id: question.id, answer: ''})
      })

      this.answersCreated = true;
    } catch(e) {
      console.log(e)
      this.$store.commit("pushMessage", {
        type: "waiting",
        title: "Something went wrong",
        text: "Please retry"
      });
    }

    this.$store.commit("hideSpinner");
  },
  methods: {
    async submitAnswers() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.post(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/surveys/" +
            this.$route.params.surveyId +
            "/answers",
          {
            answers: this.answers
          }
        );
        this.$router.push("/");
        this.$store.dispatch("getUserTasks");
      } catch (err) {
        if (_.get(err, "response.status", 500) == 409) {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Error",
            text: "You have already answered this survey"
          });
        } else {
          this.$store.commit("pushMessage", {
            type: "error",
            title: "Something went wrong",
            text: "Please retry"
          });
        }
      }

      this.$store.commit("hideSpinner");
    },
    setSelectAnswer(answerValue, index, questionId) {
      this.$set(this.answers, index, {id: questionId, answer: answerValue});
      if(this.questions.length === 1) {
        this.submitAnswers();
      }
    },
    getSelectClass(optionValue, index) {
      return this.answers[index] === optionValue
        ? "btn-primary"
        : "btn-outline-primary";
    },
    getValidationRules(type) {
      return type === "date"
        ? "required|date_format:dd/MM/yyyy"
        : "required|string";
    }
  },
  computed: {
    percCompleted() {
      return this.currentQuestionNumber !== 0
        ? Math.round(
            100 -
              (100 - (this.currentQuestionNumber * 100) / this.questions.length)
          )
        : 0;
    }
  }
};
</script>

<style scoped>
.code {
  position: relative;
}
.survey-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 65px;
  background-color: #f7f8fb;
}
.survey-bar .navigate .btn {
  border-radius: 50%;
}
body {
  position: relative;
}
body::after {
  content: "";
  opacity: 0.5;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-repeat: no-repeat;
  background-size: cover;
}
nav.navbar {
  background-color: transparent !important;
}
.pac-container,
.ui-datepicker {
  z-index: 999999 !important;
}
body.remove-requested .pac-container {
  margin-top: -70px;
}
@media (max-width: 767px) {
  .survey-bar {
    bottom: 65px;
  }
  main.code {
    height: calc(100vh - 271px);
  }
}
footer {
  display: none !important;
}
.form-group > div.hint {
  position: absolute;
  display: none;
  width: 100%;
  padding: 0.375rem 0;
  font-size: 14px;
  line-height: 1.6;
  color: #a8a8a9;
  font-weight: bold;
  background-color: transparent;
  background-image: none;
  background-clip: padding-box;
  border: none;
  top: 0;
  left: 0;
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  z-index: 1;
}

.btn-outline-primary:focus {
    color: #fff;
    background-color: #0b5aa0;
    border-color: #0b5aa0;
}

</style>
<style>
.pac-container {
  z-index: 3000 !important;
  pointer-events: auto !important;
}
</style>
